import { createSlice } from "@reduxjs/toolkit";
import {
  register,
  login,
  logout,
  whoAmI,
  getNotifications,
  acceptTerms,
  verifyMfa,
} from "./actions";
import { RootState } from "../../utils/types";

const initialState: RootState["user"] & {
  mfaRequired?: boolean;
  tempToken?: string | null;
} = {
  status: "idle",
  message: "",
  user: null,
  mfaRequired: false,
  tempToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
    },
    resetMfa: (state) => {
      state.mfaRequired = false;
      state.tempToken = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login flow
      .addCase(login.pending, (state) => {
        state.status = "loading";
      })
      .addCase(login.fulfilled, (state, action: any) => {
        state.status = "success";
      
        if (action.payload?.mfaRequired) {
          state.mfaRequired = true;
          state.tempToken = action.payload.tempToken;
          state.user = null;
        } else {
          state.user = action.payload.user ?? action.payload; 
          state.mfaRequired = false;
          state.tempToken = null;
        }
      })
      .addCase(login.rejected, (state) => {
        state.user = null;
        state.status = "failed";
      })

      // MFA verify flow
      .addCase(verifyMfa.pending, (state) => {
        state.status = "loading";
      })
      .addCase(verifyMfa.fulfilled, (state, action: any) => {
        state.status = "success";
        state.user = action.payload.user ?? action.payload; 
        state.mfaRequired = false;
        state.tempToken = null;
      })
      .addCase(verifyMfa.rejected, (state) => {
        state.status = "failed";
      })

      // WhoAmI flow - for checking existing auth
      .addCase(whoAmI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(whoAmI.fulfilled, (state, action: any) => {
        state.status = "success";
        state.user = action.payload;
        // Reset MFA state when whoAmI succeeds (user already authenticated)
        state.mfaRequired = false;
        state.tempToken = null;
      })
      .addCase(whoAmI.rejected, (state) => {
        state.status = "failed";
        state.user = null;
        state.mfaRequired = false;
        state.tempToken = null;
      });
  },
});

export default authSlice.reducer;
export const { reset, resetMfa } = authSlice.actions;
